export const NATIONAL_DAYS = [
  { slug: "republic-day", month: 1, day: 26, title: "Happy Republic Day", hindi: "गणतंत्र दिवस की शुभकामनाएँ", note: "On 26 January 1950 the Constitution of India came into force. जय हिन्द!" },
  { slug: "martyrs-day", month: 1, day: 30, title: "Shaheed Diwas", hindi: "शहीद दिवस", note: "Remembering Mahatma Gandhi and all who gave their lives for Bharat." },
  { slug: "kargil-vijay-diwas", month: 7, day: 26, title: "Kargil Vijay Diwas", hindi: "कारगिल विजय दिवस", note: "Saluting the bravehearts who won back the heights in 1999." },
  { slug: "independence-day", month: 8, day: 15, title: "Happy Independence Day", hindi: "स्वतंत्रता दिवस की शुभकामनाएँ", note: "Celebrating freedom since 15 August 1947. वन्दे मातरम्!" },
  { slug: "teachers-day", month: 9, day: 5, title: "Happy Teachers' Day", hindi: "शिक्षक दिवस", note: "Honouring Dr. Sarvepalli Radhakrishnan and every guru who lit a lamp." },
  { slug: "hindi-diwas", month: 9, day: 14, title: "Hindi Diwas", hindi: "हिन्दी दिवस की शुभकामनाएँ", note: "Celebrating the day Hindi was adopted as an official language in 1949." },
  { slug: "gandhi-jayanti", month: 10, day: 2, title: "Gandhi Jayanti", hindi: "गांधी जयंती", note: "Remembering the Mahatma and Lal Bahadur Shastri. Be the change." },
  { slug: "national-unity-day", month: 10, day: 31, title: "Rashtriya Ekta Diwas", hindi: "राष्ट्रीय एकता दिवस", note: "Honouring Sardar Vallabhbhai Patel, the Iron Man who united India." },
  { slug: "childrens-day", month: 11, day: 14, title: "Happy Children's Day", hindi: "बाल दिवस", note: "For the young citizens who will write the next chapter of Bharat." },
  { slug: "constitution-day", month: 11, day: 26, title: "Samvidhan Diwas", hindi: "संविधान दिवस", note: "On 26 November 1949 India adopted its Constitution. We, the people." },
  { slug: "navy-day", month: 12, day: 4, title: "Indian Navy Day", hindi: "नौसेना दिवस", note: "Saluting the guardians of our seas. शं नो वरुणः" },
  { slug: "vijay-diwas", month: 12, day: 16, title: "Vijay Diwas", hindi: "विजय दिवस", note: "Commemorating the 1971 victory and the courage of our armed forces." },
];

const FESTIVAL_INFO = {
  pongal: { title: "Happy Pongal & Makar Sankranti", hindi: "पोंगल और मकर संक्रांति की शुभकामनाएँ", note: "The harvest is in and the sun turns north. Thai pirandhal, vazhi pirakkum!", days: 2 },
  holi: { title: "Happy Holi", hindi: "होली की हार्दिक शुभकामनाएँ", note: "Colours, sweets and the burning away of winter. बुरा न मानो, होली है!", days: 1 },
  eid: { title: "Eid Mubarak", hindi: "ईद मुबारक", note: "Wishing peace, sweetness and togetherness to all celebrating Eid al-Fitr.", days: 1 },
  navratri: { title: "Shubh Navratri", hindi: "शुभ नवरात्रि", note: "Nine nights of Shakti, Garba and Durga Puja, ending in Vijayadashami.", days: 10 },
  diwali: { title: "Happy Diwali", hindi: "दीपावली की हार्दिक शुभकामनाएँ", note: "May the lamps of Deepavali light every home in Bharat. शुभ दीपावली!", days: 2 },
};

// Dates per Drik Panchang (New Delhi); Eid depends on moon sighting and may shift by a day.
const LUNAR_DATES = [
  { slug: "pongal", year: 2026, month: 1, day: 14 },
  { slug: "holi", year: 2026, month: 3, day: 4 },
  { slug: "eid", year: 2026, month: 3, day: 21 },
  { slug: "navratri", year: 2026, month: 10, day: 11 },
  { slug: "diwali", year: 2026, month: 11, day: 8 },
  { slug: "pongal", year: 2027, month: 1, day: 15 },
  { slug: "eid", year: 2027, month: 3, day: 10 },
  { slug: "holi", year: 2027, month: 3, day: 22 },
  { slug: "navratri", year: 2027, month: 9, day: 30 },
  { slug: "diwali", year: 2027, month: 10, day: 29 },
  { slug: "pongal", year: 2028, month: 1, day: 15 },
  { slug: "eid", year: 2028, month: 2, day: 26 },
  { slug: "holi", year: 2028, month: 3, day: 11 },
  { slug: "navratri", year: 2028, month: 9, day: 19 },
  { slug: "diwali", year: 2028, month: 10, day: 17 },
];

export const LUNAR_FESTIVALS = LUNAR_DATES.map((d) => ({ ...d, ...FESTIVAL_INFO[d.slug] }));

const dayDiff = (a, b) => Math.round((a - b) / 86400000);

export function todaysNationalDay(date = new Date(), override = null) {
  if (override) {
    return NATIONAL_DAYS.find((d) => d.slug === override) || LUNAR_FESTIVALS.find((d) => d.slug === override) || null;
  }
  const today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const lunar = LUNAR_FESTIVALS.find((f) => {
    const start = new Date(f.year, f.month - 1, f.day);
    const diff = dayDiff(today, start);
    return diff >= 0 && diff < f.days;
  });
  if (lunar) return lunar;
  const m = date.getMonth() + 1;
  const d = date.getDate();
  return NATIONAL_DAYS.find((x) => x.month === m && x.day === d) || null;
}
